import React, { FC, lazy } from 'react';

import { Button, ButtonVariant } from '@/shared/ui';
import { useOpenConnectWalletModal } from '@/shared/hooks/useOpenConnectWalletModal';
import useLocalFeatureFlag from '@/shared/hooks/useLocalFeatureFlag';
import { Features } from '@/shared/configs/features';

type ConnectWalletWrapperProps = {
    noWallet?: boolean;
    children: React.ReactNode;
};

const LazyConnectWalletWrapper = lazy(() =>
    import('./v2/ConnectWalletWrapper').then((module) => ({
        default: module.ConnectWalletWrapper,
    })),
);

const BaseConnectWalletWrapper: FC<ConnectWalletWrapperProps> = ({ children, noWallet }) => {
    const handleConnectWalletClick = useOpenConnectWalletModal();

    if (noWallet) {
        return (
            <Button
                variant={ButtonVariant.Primary}
                onClick={handleConnectWalletClick}
                name='connect-wallet'
                className='flex justify-center items-center w-[152px] text-md h-[44px]'
            >
                Connect Wallet
            </Button>
        );
    }

    return <>{children}</>;
};

export const ConnectWalletWrapper: FC<ConnectWalletWrapperProps> = ({ noWallet, children }) => {
    const isNewWalletConnect = useLocalFeatureFlag(Features.NewWalletConnect, true);

    if (!isNewWalletConnect) {
        return <BaseConnectWalletWrapper noWallet={noWallet}>{children}</BaseConnectWalletWrapper>;
    }
    return (
        <React.Suspense fallback={null}>
            <LazyConnectWalletWrapper>{children}</LazyConnectWalletWrapper>
        </React.Suspense>
    );
};
